import { reactive } from 'vue'
import type { Requirement, DefinitionStatus, DevelopmentStatus, Priority, RequirementType } from '@/types'

export interface RequirementsState {
  requirements: Requirement[]
  selectedRequirement: Requirement | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    projectId: string
    applicationId: string
    epicId: string
    type: RequirementType | ''
    definitionStatus: DefinitionStatus | ''
    developmentStatus: DevelopmentStatus | ''
    priority: Priority | ''
    assignedTo: string
    hasNoEpic: boolean
  }
}

export const getInitialState = (): RequirementsState => ({
  requirements: [],
  selectedRequirement: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    projectId: '',
    applicationId: '',
    epicId: '',
    type: '',
    definitionStatus: '',
    developmentStatus: '',
    priority: '',
    assignedTo: '',
    hasNoEpic: false,
  },
})

export const createState = (): RequirementsState => {
  return reactive(getInitialState())
}

export const resetState = (state: RequirementsState): void => {
  const initial = getInitialState()
  state.requirements = initial.requirements
  state.selectedRequirement = initial.selectedRequirement
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
